
import DodoneStats from 'app/dodones/shared/Stats'
import DodoneCommentFieldTrigger from 'app/dodones/fields/comment/Trigger'

export default ({ dodone }) => {
  return (
    <>
      <DodoneStats dodone={ dodone } />
      <DodoneCommentFieldTrigger dodone={ dodone } />
    </>
  )
};
